<template>
  <div>
    <what3words-autosuggest :id="'w3w_'+id" variant="inherit" api_key="PKW7RVMZ" invalid_address_error_message="">
      <v-text-field
          autocomplete="off"
          :id="id"
          :ref="id"
          :placeholder="label"
          v-model="autocompleteText"
          @keydown.tab="tabber($event)"
          @focus="onFocus()"
          @blur="onBlur()"
          @input="input"
          @paste="paste"
          :label="label"
          :height="30"
          :append-icon="removeIcon"
          onclick="this.select();"
          hide-details
          :error-messages="valid() == true ? null : [valid()]"
          :rules="rules"
          dense
          outlined
          class="font-weight-500"
      >
        <template v-slot:append v-if="removable">
          <v-icon color="red" small @click="remove"> mdi-close </v-icon>
        </template>
      </v-text-field>
    </what3words-autosuggest>
  </div>
</template>

<script>
import axios from "axios";
import { setTimeout } from "timers";

axios.defaults.withCredentials = true;

export default {
  name: "BookingLocationInput",
  components: {},
  model: {
    prop: "location",
    event: "locationChanged",
  },
  computed: {
    removeIcon: function () {
      if (this.removable) {
        return "mdi-minus-circle-outline";
      } else {
        return "";
      }
    },
  },
  props: {
    id: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      required: false,
    },
    enableGeolocation: {
      type: Boolean,
      default: true,
    },
    location: Object,
    removable: {
      type: Boolean,
      default: false,
    },
    error: String,
    soloField: {
      type: Boolean,
      default: true,
    },
    singleLineField: {
      type: Boolean,
      default: true,
    },
    soloInvertedField: {
      type: Boolean,
      default: false,
    },
    flatField: {
      type: Boolean,
      default: false,
    },
    backgroundColour: {
      type: String,
      default: "grey lighten-3",
    },
    rules: Array,
  },
  data: function () {
    return {
      autocompleteText:
        this.location.description != null ? this.location.description : "",
      autocomplete: null,
      timer: null,
      focused: false,
      loading: false,
    };
  },
  watch: {
    location: {
      handler(loc) {
        this.autocompleteText = this.location.description;
      },
      deep: true,
    },
  },
  mounted: function () {
    var vm = this;

    this.WhenGoogleLoadedDo(function () {
      // console.log("Can setup as google loaded");
      vm.setup(vm);
    });
  },
  beforeDestroy: function () {
    clearTimeout(this.timer);
  },
  methods: {
      async getCoordinatesFromWords(words) {
          try {
              // Since axios automatically URL encodes parameters, no extra steps are required here.
              const response = await axios.get(`${this.$store.state.apiUrl}/location/getCoordinates`, {
                  params: {
                      words: words
                  },
              });
              
              // You can return the full response if required or just the data
              return response.data;
          } catch (error) {
              console.error("Error fetching coordinates:", error);
              throw error; // Or handle it in a way that suits your application
          }
      },
    WhenGoogleLoadedDo: function (fnt) {
      var vm = this;
      if (typeof google != "undefined") {
        // console.log("Google loaded!");
        fnt();
      } else {
        // console.log("Google not loaded!");
        setTimeout(function () {
          (function (fnt) {
            vm.WhenGoogleLoadedDo(fnt);
          })(fnt);
        }, 500); // You can set timer as you wish //
      }
    },
    remove: function () {
      this.$emit("removePressed", "");
    },
    valid: function () {
      var valid =
        (this.location.id != null && this.autocompleteText != null) ||
        (this.location.id == null &&
          (this.autocompleteText == null || this.autocompleteText == "") &&
          this.error == null);

      if (this.focused || this.loading) {
        return true;
      }

      if (valid && this.error == null) {
        return true;
      } else {
        if (this.error != null) {
          return this.error;
        }

        return "Please select a location from the dropdown list";
      }
    },
    clear: function (e) {
      this.autocompleteText = "";
    },
    tabber: function (e) {
      this.autocompleteText = document.getElementById(this.id).value;
    },
    completed: function (vm, loc) {
      console.log("Completed Location Update");

      loc.invalid = false;
      loc.custom = false;

      vm.$emit("locationChanged", loc);

      vm.$nextTick(function () {
        vm.$refs[vm.id].validate();
      });
    },
    setup: function (vm) {
      const options = {
        // types: [this.types]
      };
      if (this.country) {
        options.componentRestrictions = {
          country: this.country,
        };
      }
      var input = document.getElementById(this.id);
      input.placeholder = "";
      this.autocomplete = new google.maps.places.Autocomplete(input, options);

      let circle = new google.maps.Circle({
        center: this.$store.state.center,
        radius: 10000,
      });

      this.autocomplete.setBounds(circle.getBounds());

      var vm = this;

      this.autocomplete.addListener("place_changed", () => {
        console.log("Place changed");
        console.log("Place changed new");
        vm.loading = true;

        let place = this.autocomplete.getPlace();
        console.log('place is', place)
        if (!place.geometry) {
          // console.log("no results found");
          this.$emit("no-results-found", place);
          this.loading = false;
          return;
        }

        // console.log(place);
        let addressComponents = {
          street_number: "short_name",
          route: "long_name",
          locality: "long_name",
          administrative_area_level_1: "short_name",
          country: "long_name",
          postal_code: "short_name",
        };
        let returnData = {};
        if (place.address_components !== undefined) {
          // Get each component of the address from the place details
          for (let i = 0; i < place.address_components.length; i++) {
            let addressType = place.address_components[i].types[0];
            if (addressComponents[addressType]) {
              let val =
                place.address_components[i][addressComponents[addressType]];
              returnData[addressType] = val;
            }
          }
          returnData["latitude"] = place.geometry.location.lat();
          returnData["longitude"] = place.geometry.location.lng();
          // return returnData object and PlaceResult object
          console.log('place returned data, ', returnData)
          console.log('place object, ', place)

          var address = place.formatted_address;

          if (place.types.includes("establishment")) {
            address = place.name + ", " + address;
          }

          this.autocompleteText = address;
          this.$emit("placechanged", returnData, place);
          console.log('place types: ', place.types[0])
          this.sendLocationToServer(
            place.geometry.location.lat(),
            place.geometry.location.lng(),
            this.autocompleteText,
            place.types[0],
          function (loc) {
              vm.completed(vm, loc);
            },
          );
        }
      });

       const w3wAutosuggest = document.getElementById("w3w_" + this.id);
       if (w3wAutosuggest) {
           
           w3wAutosuggest.addEventListener(
               "selected_suggestion",
               ({
                    detail: {
                        suggestion: { words }
                    }
                }) => {
                   console.log("Suggestion selected");
                   console.log(words);
                   
                   var wordsInternal = JSON.parse(JSON.stringify(words));
                   
                   console.log(wordsInternal);
                   
                   this.getCoordinatesFromWords(words)
                       .then(function(response) {
                           console.log("[convertToCoordinates]", response);
                           
                           var geocoder = new google.maps.Geocoder();
                           
                           geocoder.geocode({ location: {lat: response.coordinates.lat, lng: response.coordinates.lng} }, function (
                               results,
                               status
                           ) {
                               if (status === "OK") {
                                   console.log(results);
                                   
                                   let addressComponents = {
                                       street_number: "short_name",
                                       route: "long_name",
                                       locality: "long_name",
                                       administrative_area_level_1: "short_name",
                                       country: "long_name",
                                       postal_code: "short_name",
                                   };
                                   let returnData = {};
                                   
                                   var place = results[0];
                                   
                                   if (place.address_components !== undefined) {
                                       // Get each component of the address from the place details
                                       for (let i = 0; i < place.address_components.length; i++) {
                                           let addressType = place.address_components[i].types[0];
                                           if (addressComponents[addressType] != undefined) {
                                               let val =
                                                   place.address_components[i][
                                                       addressComponents[addressType]
                                                       ];
                                               returnData[addressType] = val;
                                           }
                                       }
                                       
                                       returnData["latitude"] = place.geometry.location.lat();
                                       returnData["longitude"] = place.geometry.location.lng();
                                       // return returnData object and PlaceResult object
                                       
                                       var address = place.formatted_address;
                                       var type = place.types[0];
                                       
                                       if (
                                           place.types.includes("establishment") &&
                                           place.name != "undefined" &&
                                           place.name != undefined &&
                                           place.name != null
                                       ) {
                                           // console.log("PLACE NAME " + place.name);
                                           address = place.name + ", " + address;
                                       }
                                       
                                       console.log(address)
                                       console.log(wordsInternal)
                                       
                                       vm.autocompleteText = vm.location.address
                                       vm.location.description = address;
                                       vm.location.w3w = wordsInternal
                                       
                                       vm.sendLocationToServer(
                                           response.coordinates.lat,
                                           response.coordinates.lng,
                                           address,
                                           type,
                                           function (loc) {
                                               loc.w3w = '///'+wordsInternal;
                                               vm.$emit('locationChanged', loc);
                                               vm.$nextTick(() => {
                                                   vm.$refs[vm.id].validate();
                                               });
                                           },
                                           wordsInternal
                                       );
                                   }
                               } else {
                                   window.alert("Geocoder failed due to: " + status);
                               }
                           });
                       });
               })
       }
    },
    sendLocationToServer(latitude, longitude, description,type, success, words ) {

      console.log('Location type is: ', type)
      var params = {
          lat: latitude,
          lon: longitude,
          description: description,
          w3w: words,
          type: type
        };

      axios({
        url: `${this.$store.state.apiUrl}/location/add`,
        method: "POST",
        params: params,
        headers: {
          "Content-Type": "application/json",
        },
      })
        .then(function (res) {
          // console.log(res.data);
          var loc = {
            id: res.data.id,
            description: res.data.description,
            latLng: {
              latitude: res.data.lat,
              longitude: res.data.lon,
            },
          };

          success(loc);
        })
        .catch((err) => console.error(err));
    },
    paste(evt) {
      console.log("PASTE")
      this.input(evt.clipboardData.getData('text/plain'))
    },
    input(value) {
      
      this.location.invalid = true;
      this.location.custom = true;

      this.location.description = value;

      console.log("Setting location to custom");

      if (value == "") {
          $(".pac-container").css("visibility", "hidden"); 
          $(".what3words-autosuggest-suggestions").css("visibility", "hidden")  
      } else if (value.startsWith('/' )) {
          console.log("Unbind autocomplete");
          $(".pac-container").css("visibility", "hidden");
          $(".what3words-autosuggest-suggestions").css("visibility", "visible")
      } else {
          $(".pac-container").css("visibility", "visible");
          $(".what3words-autosuggest-suggestions").css("visibility", "hidden")
      }
    },
    onFocus() {
      // console.log("Focused");
      this.focused = true;
      this.geolocate();
    },
    onBlur() {
      // console.log("Focused");
      this.focused = false;
      this.$emit("blur");
    },
    geolocate() {
      try {
        if (this.enableGeolocation) {
          if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition((position) => {
              let geolocation = {
                lat: position.coords.latitude,
                lng: position.coords.longitude,
              };
              let circle = new google.maps.Circle({
                center: geolocation,
                radius: position.coords.accuracy,
              });
              this.autocomplete.setBounds(circle.getBounds());
            });
          }
        }
      } catch (e) {
        console.log(e);
      }
    },
    remove() {
      this.$emit("removePressed");
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">

.what3words-autosuggest-state {
    top: 12px !important;
}

.what3words-autosuggest-error-wrapper {
    visibility: hidden !important;
} 

.what3words-autosuggest-state {
   visibility: hidden !important;
}

.font-weight-500 {
  font-weight: 500 !important;
}
</style>
